// extracted by mini-css-extract-plugin
export default {"img":"card_img__pofI5","title":"card_title__ec0Je","titleInfo":"card_titleInfo__qYxFw"};